export const Address = async() => {
    if (window && window.ethereum) {
      if (window.ethereum.isMiniPay) {
        let accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
          params: [],
        });
         return accounts[0];
      }
      }
      return '0x7784d7Cc9F0Dc82EE1cCA9aD9d1f17f1a81c5d71'
  };